// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_signIn__qGh\\+T {
  height: 100vh;
  min-height: 100vh;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA {
  height: 100%;
  overflow: hidden;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_logo__W\\+opJ {
  position: fixed;
  left: 33px;
  top: 26px;
  z-index: 99;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g {
  width: 72.87%;
  height: 100%;
  background-color: var(--si-bg-color);
  color: var(--font-color);
  margin-left: 27.1354%;
  overflow: hidden;
  position: relative;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU {
  height: 100%;
  margin-left: 184px;
  margin-right: 135px;
  overflow: auto;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_textLogoBigContainer__6nX-X {
  width: 100%;
  margin-top: 149px;
  margin-bottom: 59px;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_textLogoBigContainer__6nX-X .Login_textLogoBig__\\+1W82 {
  width: 27.803%;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_signInLabel__yZdyS {
  color: #7177EC;
  font-family: Red Hat Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.42px;
  text-decoration: none;
  margin-bottom: 13px;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_signInHeading__GDWCn {
  font-family: Red Hat Display;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 58.5px;
  background: var(--si-ri-heading);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 9px;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_connectBox__mormn {
  width: 508px;
  height: 62px;
  background-color: var(--si-lf-bg-colr);
  border: 1px solid var(--m-tt-border);
  border-radius: 64px;
  display: flex;
  margin-top: 30px;
  margin-bottom: 23px;
  padding: 10px 13px 10px 20px;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_connectBox__mormn .Login_connectContent__Ku89L {
  display: flex;
  margin-right: auto;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_connectBox__mormn .Login_connectContent__Ku89L .Login_connectLabel__XSp\\+6 {
  color: #777778;
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 44px;
  letter-spacing: -0.5px;
  margin-left: 16px;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_connectBox__mormn button {
  width: 132px !important;
  height: 38px !important;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_connectBox__mormn button svg {
  top: 17%;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_mainImage__2ZCJo {
  width: calc(100% - 315px);
  height: 18.85vw;
  margin-top: auto;
  position: absolute;
  bottom: 0;
  overflow: hidden;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_mainImage__2ZCJo img {
  width: 100%;
  position: absolute;
  top: 0;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_moreAbout__yALLH {
  width: 27.1354%;
  height: 100%;
  background-color: var(--si-lf-bg-colr);
  color: var(--font-color);
  float: left;
  position: fixed;
  left: 0;
  top: 0;
  overflow: hidden;
  z-index: 98;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_moreAbout__yALLH .Login_moreIcon__yuBh1 {
  width: 28.023%;
  margin: 94px auto auto auto;
  text-align: center;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_moreAbout__yALLH .Login_moreTitle__HVBtJ {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
  margin-bottom: 25px;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_moreAbout__yALLH .Login_moreItems__uuOEk {
  text-align: center;
  max-height: 315px;
  overflow-y: auto;
  overflow-x: hidden;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_moreAbout__yALLH .Login_moreItem__biPvb {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 27px;
}
.Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_moreAbout__yALLH .Login_moreItemText__y1xXB {
  margin-left: 11px;
}

@media screen and (max-width: 1000px) {
  .Login_signIn__qGh\\+T {
    width: 100%;
    height: auto;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA {
    display: flex;
    flex-direction: column-reverse;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_logo__W\\+opJ {
    display: none;
    position: absolute;
    z-index: 10;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g {
    width: 100%;
    flex: 100% 1;
    float: left;
    margin-left: 0;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU {
    height: auto;
    text-align: center;
    margin-left: 0;
    margin-right: 0;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_textLogoBigContainer__6nX-X {
    background-color: var(--sb-bg-color);
    border: 1px solid var(--m-tt-border);
    margin-top: 0;
    margin-bottom: 26px;
    padding: 13px;
    position: fixed;
    text-align: center;
    top: 0;
    z-index: 99;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_textLogoBigContainer__6nX-X .Login_textLogoBig__\\+1W82 {
    width: 43.8461%;
    margin: auto;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_signInLabel__yZdyS {
    color: #FFA329;
    margin-top: 24vw;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_signInHeading__GDWCn {
    background: var(--si-ri-heading);
    background-clip: text;
    font-size: 24px;
    margin-bottom: -13px;
    text-align: center;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_connectBox__mormn {
    width: 87.1795%;
    border: 1px solid var(--m-tt-border);
    margin: 26px auto 17px auto;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_connectBox__mormn .Login_connectContent__Ku89L .Login_connectLabel__XSp\\+6 {
    font-size: 15px;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_connectBox__mormn button {
    position: relative;
    right: 0;
    bottom: 0 !important;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_mainImage__2ZCJo {
    width: calc(100% - 50px);
    height: auto;
    display: flex;
    margin: 17px 25px 27px;
    position: relative;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_main__DVK0g .Login_mainContainer__zxdpU .Login_mainImage__2ZCJo img {
    width: 100%;
    position: relative;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_moreAbout__yALLH {
    width: 100%;
    flex: 100% 1;
    position: relative;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_moreAbout__yALLH .Login_moreIcon__yuBh1 {
    width: 17.9487%;
    margin: 18px auto 6px;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_moreAbout__yALLH .Login_moreTitle__HVBtJ {
    font-size: 20px;
    margin-bottom: 23px;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_moreAbout__yALLH .Login_moreItems__uuOEk {
    max-height: 150px;
  }
  .Login_signIn__qGh\\+T .Login_signInContainer__rxQvA .Login_moreAbout__yALLH .Login_moreItem__biPvb {
    display: flex;
    margin-bottom: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;AACF;AACE;EACE,YAAA;EACA,gBAAA;AACJ;AACI;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AACN;AAEI;EACE,aAAA;EACA,YAAA;EACA,oCAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAAN;AAEM;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAAR;AAEQ;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AAAV;AAEU;EACE,cAAA;AAAZ;AAIQ;EACE,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AAFV;AAKQ;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;EACA,kBAAA;AAHV;AAMQ;EACE,YAAA;EACA,YAAA;EACA,sCAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;AAJV;AAMU;EACE,aAAA;EACA,kBAAA;AAJZ;AAMY;EACE,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAJd;AAQU;EACE,uBAAA;EACA,uBAAA;AANZ;AAQY;EACE,QAAA;AANd;AAWQ;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AATV;AAYQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;AAVV;AAeI;EACE,eAAA;EACA,YAAA;EACA,sCAAA;EACA,wBAAA;EACA,WAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;EACA,WAAA;AAbN;AAeM;EACE,cAAA;EACA,2BAAA;EACA,kBAAA;AAbR;AAgBM;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAdR;AAiBM;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAfR;AAkBM;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;AAhBR;AAmBM;EACE,iBAAA;AAjBR;;AAuBA;EACE;IACE,WAAA;IACA,YAAA;EApBF;EAsBE;IACE,aAAA;IACA,8BAAA;EApBJ;EAsBI;IACE,aAAA;IACA,kBAAA;IACA,WAAA;EApBN;EAuBI;IACE,WAAA;IACA,YAAA;IACA,WAAA;IACA,cAAA;EArBN;EAuBM;IACE,YAAA;IACA,kBAAA;IACA,cAAA;IACA,eAAA;EArBR;EAuBQ;IACE,oCAAA;IACA,oCAAA;IACA,aAAA;IACA,mBAAA;IACA,aAAA;IACA,eAAA;IACA,kBAAA;IACA,MAAA;IACA,WAAA;EArBV;EAuBU;IACE,eAAA;IACA,YAAA;EArBZ;EAyBQ;IACE,cAAA;IACA,gBAAA;EAvBV;EA0BQ;IACE,gCAAA;IACH,qBAAA;IACG,eAAA;IACA,oBAAA;IACA,kBAAA;EAxBV;EA2BQ;IACE,eAAA;IACA,oCAAA;IACA,2BAAA;EAzBV;EA4BY;IACE,eAAA;EA1Bd;EA8BU;IACE,kBAAA;IACA,QAAA;IACA,oBAAA;EA5BZ;EAgCQ;IACE,wBAAA;IACA,YAAA;IACA,aAAA;IACA,sBAAA;IACA,kBAAA;EA9BV;EAiCQ;IACE,WAAA;IACA,kBAAA;EA/BV;EAoCI;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EAlCN;EAoCM;IACE,eAAA;IACA,qBAAA;EAlCR;EAqCM;IACE,eAAA;IACA,mBAAA;EAnCR;EAsCM;IACE,iBAAA;EApCR;EAuCM;IACE,aAAA;IACA,mBAAA;EArCR;AACF","sourcesContent":[".signIn {\n  height: 100vh;\n  min-height: 100vh;\n\n  .signInContainer {\n    height: 100%;\n    overflow: hidden;\n\n    .logo {\n      position: fixed;\n      left: 33px;\n      top: 26px;\n      z-index: 99;\n    }\n\n    .main {\n      width: 72.87%;\n      height: 100%;\n      background-color: var(--si-bg-color);\n      color: var(--font-color);\n      margin-left: 27.1354%;\n      overflow: hidden;\n      position: relative;\n\n      .mainContainer {\n        height: 100%;\n        margin-left: 184px;\n        margin-right: 135px;\n        overflow: auto;\n\n        .textLogoBigContainer {\n          width: 100%;\n          margin-top: 149px;         \n          margin-bottom: 59px;\n\n          .textLogoBig {\n            width: 27.803%;\n          }\n        }\n  \n        .signInLabel {\n          color: #7177EC;\n          font-family: Red Hat Display;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 20px; /* 142.857% */\n          letter-spacing: 0.42px;\n          text-decoration: none;\n          margin-bottom: 13px;\n        }\n\n        .signInHeading {\n          font-family: Red Hat Display;\n          font-size: 40px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 58.5px;\n          background: var(--si-ri-heading);\n          -webkit-background-clip: text;\n          -webkit-text-fill-color: transparent;\n          margin-bottom: 9px;\n        }\n\n        .connectBox {\n          width: 508px;\n          height: 62px;\n          background-color: var(--si-lf-bg-colr);\n          border: 1px solid var(--m-tt-border) ;\n          border-radius: 64px;\n          display: flex;\n          margin-top: 30px;\n          margin-bottom: 23px;\n          padding: 10px 13px 10px 20px;\n\n          .connectContent {\n            display: flex;\n            margin-right: auto;\n\n            .connectLabel {\n              color: #777778;\n              font-family: Red Hat Display;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 44px;\n              letter-spacing: -0.5px;\n              margin-left: 16px;\n            }\n          }\n\n          button {\n            width: 132px !important;\n            height: 38px !important;\n\n            svg {\n              top: 17%;\n            }\n          }\n        }\n\n        .mainImage {\n          width: calc(100% - 315px);\n          height: 18.85vw;\n          margin-top: auto ;\n          position:absolute;\n          bottom: 0;\n          overflow: hidden;\n        }\n\n        .mainImage img {\n          width: 100%;\n          position: absolute;\n          top: 0;\n        }\n      }\n    }\n\n    .moreAbout {\n      width: 27.1354%;\n      height: 100%;\n      background-color: var(--si-lf-bg-colr);\n      color: var(--font-color);\n      float: left;\n      position: fixed;\n      left: 0;\n      top: 0;\n      overflow: hidden;\n      z-index: 98;\n\n      .moreIcon {\n        width: 28.023%;\n        margin: 94px auto auto auto;\n        text-align: center;\n      }\n\n      .moreTitle {\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        text-align: center;\n        margin-bottom: 25px;\n      }\n\n      .moreItems {\n        text-align: center;\n        max-height: 315px;\n        overflow-y: auto;\n        overflow-x: hidden;\n      }\n\n      .moreItem {\n        display: flex;\n        align-items: flex-start;\n        justify-content: center;\n        margin-bottom: 27px;\n      }\n\n      .moreItemText {\n        margin-left: 11px;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .signIn {\n    width: 100%;\n    height: auto;\n\n    .signInContainer {\n      display: flex;\n      flex-direction: column-reverse;\n\n      .logo {\n        display: none;\n        position: absolute;\n        z-index: 10;\n      }\n\n      .main {\n        width: 100%;\n        flex: 100%;\n        float: left;\n        margin-left: 0;\n  \n        .mainContainer {\n          height: auto;\n          text-align: center;\n          margin-left: 0;\n          margin-right: 0;\n\n          .textLogoBigContainer {\n            background-color: var(--sb-bg-color);\n            border: 1px solid var(--m-tt-border);\n            margin-top: 0;\n            margin-bottom: 26px;\n            padding: 13px;\n            position: fixed;\n            text-align: center;\n            top: 0;\n            z-index: 99;\n\n            .textLogoBig {\n              width: 43.8461%;  \n              margin: auto;\n            }\n          }\n        \n          .signInLabel {\n            color: #FFA329;\n            margin-top: 24vw;\n          }\n  \n          .signInHeading {\n            background: var(--si-ri-heading);\n\t        background-clip: text;\n            font-size: 24px;\n            margin-bottom: -13px;\n            text-align: center;\n          }\n  \n          .connectBox {\n            width: 87.1795%;\n            border: 1px solid var(--m-tt-border) ;\n            margin:26px auto 17px auto;\n\n            .connectContent {\n              .connectLabel {\n                font-size: 15px;\n              }\n            }\n\n            button {\n              position: relative;\n              right: 0;\n              bottom: 0 !important;\n            }\n          }  \n\n          .mainImage {\n            width: calc(100% - 50px);\n            height: auto;\n            display: flex;\n            margin: 17px 25px 27px;\n            position: relative;\n          }\n\n          .mainImage img {\n            width: 100%;\n            position: relative;\n          }\n        }\n      }\n  \n      .moreAbout {\n        width: 100%;\n        flex: 100%;\n        position: relative;\n\n        .moreIcon {\n          width: 17.9487%;\n          margin: 18px auto 6px;\n        }\n  \n        .moreTitle {\n          font-size: 20px;\n          margin-bottom: 23px;\n        }\n  \n        .moreItems {\n          max-height: 150px;\n        }\n  \n        .moreItem {\n          display: flex;\n          margin-bottom: 12px;\n        }\n      }\n    }   \n  }\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"signIn": `Login_signIn__qGh+T`,
	"signInContainer": `Login_signInContainer__rxQvA`,
	"logo": `Login_logo__W+opJ`,
	"main": `Login_main__DVK0g`,
	"mainContainer": `Login_mainContainer__zxdpU`,
	"textLogoBigContainer": `Login_textLogoBigContainer__6nX-X`,
	"textLogoBig": `Login_textLogoBig__+1W82`,
	"signInLabel": `Login_signInLabel__yZdyS`,
	"signInHeading": `Login_signInHeading__GDWCn`,
	"connectBox": `Login_connectBox__mormn`,
	"connectContent": `Login_connectContent__Ku89L`,
	"connectLabel": `Login_connectLabel__XSp+6`,
	"mainImage": `Login_mainImage__2ZCJo`,
	"moreAbout": `Login_moreAbout__yALLH`,
	"moreIcon": `Login_moreIcon__yuBh1`,
	"moreTitle": `Login_moreTitle__HVBtJ`,
	"moreItems": `Login_moreItems__uuOEk`,
	"moreItem": `Login_moreItem__biPvb`,
	"moreItemText": `Login_moreItemText__y1xXB`
};
export default ___CSS_LOADER_EXPORT___;
